import { useNavigate } from "react-router-dom";
import { useAuth, useTellescopeMutation } from "@tellescope/tanstack-query";
import { MOBILE_RETURN_SCHEME_KEY } from "./useMobileAppLogin";

interface UseGoogleLoginOptions {
  onAuthSuccess?: (authToken: string) => void;
  returnScheme?: string;
}

export const useGoogleLogin = ({ onAuthSuccess, returnScheme }: UseGoogleLoginOptions = {}) => {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();

  const googleLoginMutation = useTellescopeMutation({
    model: "users",
    method: "login_with_google",
    autoCacheUpdateStrategy: "disabled",
    onSuccess: (result: {
      authToken: string;
      user: { businessId: string; organizationIds?: string[]; requiresMFA?: boolean };
    }) => {
      loginWithToken({ authToken: result.authToken, user: result.user });
      if (result.user.requiresMFA) {
        if (onAuthSuccess && returnScheme) {
          sessionStorage.setItem(MOBILE_RETURN_SCHEME_KEY, returnScheme);
          navigate("/mobile-app/mfa", { replace: true });
        } else {
          navigate("/mfa", { replace: true });
        }
        return;
      }
      if (onAuthSuccess) {
        onAuthSuccess(result.authToken);
      } else {
        navigate("/dashboard", { replace: true });
      }
    },
  });

  const handleGoogleSuccess = (jwt: string) => {
    googleLoginMutation.mutate({ jwt });
  };

  return {
    handleGoogleSuccess,
    error: googleLoginMutation.error?.message,
    isPending: googleLoginMutation.isPending,
  };
};
